import React, { useRef, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { MTable, MCard, MSpinner } from "components/Shared";
import { getCaseHazards } from "actions/qualityAssurance";

const CaseHazards = (props) => {
  const { controlNumber } = props;

  let mounted = useRef(true);

  useEffect(() => {
    props.getCaseHazards(controlNumber);
    return () => {
      mounted.current = false;
    };
  }, []);

  let hazLevels = [];
  if (props.caseHazards) {
    props.caseHazards.forEach(s => {
      if (!hazLevels[s.hazardLevel])
        hazLevels[s.hazardLevel] = [s];
      else
        hazLevels[s.hazardLevel].push(s);
    });
  }

  const GetData = (hazardList) => {
    return hazardList.map(s => ({
      placeholder: "",
      category: s.hazardCategory.categoryName,
      count: s.hazardCount,
      subCategory: s.hazardCategory.subcategoryName,
      details: s.details
    }
    ));
  };

  const GroupHazards = (hazardList) => {
    let lastCategory = "";
    let returnList = [];
    for (let i = 0; i < hazardList.length; i++) {
      if (hazardList[i].category == lastCategory) {
        hazardList[i].category = "";
        hazardList[i].count = "";
        returnList.push(hazardList[i]);
      }
      else {
        lastCategory = hazardList[i].category;
        returnList.push(hazardList[i]);
      }
    }
    return returnList;
  };

  const GetDistinctCount = (hazardLevelGroup) => new Set(hazardLevelGroup.map(x => x.hazardCategory.categoryName)).size;

  const getHazardSummaryFields = () => {
    if (props.isFetchingCaseHazards) {
      return <MSpinner />;
    }
    if (props.caseHazards && !props.caseHazards.length) {
      return <div>No Hazards</div>;
    } else {
      let hazardTables = [];
      for (let s in hazLevels) {
        let i = hazLevels[s];
        hazardTables.push(
          <MTable
            key={s}
            columnDefinitions={[
              { name: `${s}: ${GetDistinctCount(i)}`, dataSource: "category", style: { width: "30%" } },
              { name: "Subcategory", dataSource: "subCategory", style: { width: "45%" } },
              { name: "Details", dataSource: "details", style: { width: "25%" } },
            ]}
            data={GroupHazards(GetData(i))}
          />
        );
      }
      return hazardTables;
    }
  };

  return (
    <MCard
      title="Hazard Summary"
      className="qa-case-hazards">
        {getHazardSummaryFields()}
    </MCard>
  );
};

CaseHazards.propTypes = {
  controlNumber: PropTypes.number,
  caseHazards: PropTypes.array,
  isFetchingCaseHazards: PropTypes.bool,
  getCaseHazards: PropTypes.func,
};

const mapStateToProps = state => {
  return {
    caseHazards: state.qualityAssurance.caseHazards,
    isFetchingCaseHazards: state.qualityAssurance.isFetchingCaseHazards,
  };
};

const mapDispatchToProps = dispatch => ({
  getCaseHazards(controlNumber) {
    dispatch(getCaseHazards(controlNumber));
  },
});

export default connect(mapStateToProps,mapDispatchToProps)(CaseHazards);